import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'

export default {
  getStudent(studentId: number) {
    const appStore = useAppStore()

    return axios.get<Domain.Students.Resources.MyFJV2.StudentResource>(`${appStore.daraApiBaseUrl}/students/${studentId}`)
  },

  setCurrentStudent(studentId: number) {
    const appStore = useAppStore()

    return axios.patch(`${appStore.daraApiBaseUrl}/students/${studentId}/set-current`);
  },


  updateStudentSettings(studentId: number, settings: Domain.Students.ValueObjects.StudentSettings) {
    const appStore = useAppStore()

    return axios.put<Domain.Students.Resources.MyFJV2.StudentResource>(`${appStore.daraApiBaseUrl}/students/${studentId}`, settings)
  },

  updateGroups(studentId: number, data: { year_group_id: number, year_sub_group_id: number }) {
    const appStore = useAppStore()

    return axios.patch<Domain.Students.Resources.MyFJV2.StudentResource>(`${appStore.daraApiBaseUrl}/students/${studentId}/groups`, data)
  },
}
